import { Buffer } from "buffer";
import axios from "axios";
import { AwsUploadS3 } from "../contexts/Aws";
import parseSvg from "../lib/parseSvg";
import { CreateFormData, Form } from "../types/forms";
import api from "./api";
import { map } from "lodash";

export const listForms = async (): Promise<Form[]> => {
  const response = await api.get("pessoa-p2-:stage/:stage/crm/getForms");

  return response.data;
};

export const putForm = async (data: any): Promise<any> => {
  const response = await api.put("pessoa-p2-:stage/:stage/crm/putForm", data);

  return response.data;
};

export const createForm = async (data: CreateFormData): Promise<any> => {
  const createFormData = {
    ...data,
    fields: map(data.fields, (field) => ({
      active: field.active ? 1 : 0,
      inputType: field.inputType.value,
      key: field.key?.value,
      label: field.label,
      optionSelect:
        Array.isArray(field.optionSelect) && field.optionSelect.length > 0
          ? JSON.stringify(field.optionSelect)
          : null,
      required: field.required ? 1 : 0,
      isFieldSon: field.isFieldSon ? 1 : 0,
      fieldFather: field.isFieldSon ? JSON.stringify(field.fieldFather) : null,
      ...(field.guid && { guid: field.guid }),
      ...(field.guidFather && { guidFather: field.guidFather })
    })),
  };

  const response = await api.post(
    "pessoa-p2-:stage/:stage/crm/postForm",
    createFormData
  );

  return response.data;
};

export const getAnswersForm = async (
  idField?: number,
  idForm?: number
): Promise<{ answers: any[]; count: any }> => {
  const response = await api.get("pessoa-p2-:stage/:stage/crm/getAnswerForm", {
    params: {
      idForm,
      idQuestion: idField,
    },
  });

  return response.data;
};

export const downloadQrCode = async (
  guid: string,
  companyId: number,
  funcUpload: (media: AwsUploadS3) => any
): Promise<any> => {
  const svg = await parseSvg(`qrcode-${guid}-download`);
  const file = svg.split(";base64,")[1];
  const attr = svg.split(";base64,")[0];
  const uploadQrCode = {
    file: Buffer.from(file, "base64"),
    type: attr.split(":")[1],
    bucketName: "datasalesio-imagens",
    folderName: "qrcode",
    subFolderName: `${companyId}/`,
    distinctName: false,
    name: guid,
    extension: "png",
  };

  const uriMedia = await funcUpload(uploadQrCode);

  const blobMedia = await axios.get(uriMedia, { responseType: "blob" });

  const nodeMedia = URL.createObjectURL(blobMedia.data);
  const link = document.createElement("a");
  link.href = nodeMedia;
  link.download = guid;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
